<template>
  <VContainer class="partners-sponsors" style="max-width: 1200px">
    <VRow class="mb-0 pb-0">
      <VCol cols="12" class="text-center">
        <h2 class="text-h4 font-weight-bold">Our Partners</h2>
        <p class="text-body-1">
          Trusted by industry leaders, leading brands and organizations
          worldwide
        </p>
      </VCol>
    </VRow>

    <VRow>
      <VCol cols="12">
        <div class="logo-carousel">
          <div class="logo-track" :style="trackStyle">
            <div
              v-for="(logo, index) in duplicatedLogos"
              :key="`logo-${index}`"
              class="logo-item"
            >
              <VImg
                :src="logo.src"
                :alt="logo.alt"
                contain
                height="130"
                width="220"
              />
            </div>
          </div>
        </div>
      </VCol>
    </VRow>
  </VContainer>
</template>

<script setup>
import { computed, onBeforeUnmount, onMounted, ref } from "vue";

import afdb from "@/assets/images/sponsors/afdb.png";
import giz from "@/assets/images/sponsors/giz.png";
import jica from "@/assets/images/sponsors/jica.jpeg";

// Sponsor logos - replace with your actual images
const sponsors = [
  { src: afdb, alt: "African Development Bank" },
  { src: giz, alt: "GIZ" },
  { src: jica, alt: "JICA" },
];

// Duplicate logos for infinite loop effect
const duplicatedLogos = computed(() => [...sponsors, ...sponsors, ...sponsors]);

const position = ref(0);
const animationId = ref(null);
const speed = 1; // Adjust speed as needed

const trackStyle = computed(() => ({
  transform: `translateX(${position.value}px)`,
  transition: "transform 0.5s ease-out",
}));

const animate = () => {
  position.value -= speed;

  // Reset position when half way through to create infinite loop
  if (Math.abs(position.value) >= (sponsors.length * 180) / 2) {
    position.value = 0;
  }

  animationId.value = requestAnimationFrame(animate);
};

onMounted(() => {
  animate();
});

onBeforeUnmount(() => {
  cancelAnimationFrame(animationId.value);
});
</script>

<style scoped>
.theme-text {
  color: rgb(115, 103, 240);
}

.partners-sponsors {
  overflow: hidden;
  border-radius: 16px;
  margin-block-end: 40px;
  padding-block: 80px;
  padding-inline: 0;
}

.logo-carousel {
  position: relative;
  overflow: hidden;
  inline-size: 100%;
  padding-block: 0;
  padding-inline: 0;
}

.logo-track {
  display: flex;
  gap: 40px;
  will-change: transform;
}

.logo-item {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: white;
  padding-block: 5px;
  padding-inline: 5px;
  transition: all 0.3s ease;
}

.logo-item:hover {
  box-shadow: 0 8px 25px rgba(0, 0, 0, 10%);
  transform: translateY(-5px);
}

.logo-image {
  filter: grayscale(100%);
  opacity: 0.7;
  transition: all 0.3s ease;
}

.logo-item:hover .logo-image {
  filter: grayscale(0%);
  opacity: 1;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .logo-item {
    padding-block: 8px;
    padding-inline: 16px;
  }

  .logo-image {
    block-size: 60px;
    inline-size: 140px;
  }
}

@media (max-width: 600px) {
  .partners-sponsors {
    padding-block: 40px;
    padding-inline: 0;
  }

  .logo-track {
    gap: 20px;
  }

  .logo-item {
    padding-block: 5px;
    padding-inline: 10px;
  }

  .logo-image {
    block-size: 40px;
    inline-size: 100px;
  }
}
</style>
